export function preferencesServerJson () {
  const items = {
    editMdmPreferences: {
      name: 'editMdmPreferences',
      label: 'editar las preferencias del MDM del servidor'
    },
    /* editSafeWebPreferences: {
      name: 'editSafeWebPreferences',
      label: 'editar las preferencias de Safeweb del servidor'
    }, */
    editRxartSecurePreferences: {
      name: 'editRxartSecurePreferences',
      label: 'editar las preferencias de Rxart Secure del servidor'
    }
  }

  return (items)
}
